/**
 * Zustellstatus einer E-Mail — reine Typen und Regeln ohne Abhängigkeit zur
 * HTTP-Schicht, damit Anzeige-Logik (deliveryBadge.ts) ohne Browser-Umgebung
 * testbar bleibt. Die Schnittstelle selbst liegt in deliveryApi.ts.
 */

/** Lebenszyklus eines Zustellversuchs an genau einen Empfänger. */
export type DeliveryStatus =
  | "queued"
  | "sent"
  /** Vom Mailserver angenommen, keine Zustellbestätigung verfügbar (SMTP/Postmark/Test). */
  | "accepted"
  | "delivered"
  | "deferred"
  | "bounced"
  | "complained"
  | "failed";

/** Meldet, ob ein Status die Aufmerksamkeit des Anwenders erfordert. */
export function isDeliveryProblem(status: DeliveryStatus | undefined | null): boolean {
  return status === "bounced" || status === "complained" || status === "failed";
}
